module.exports = __webpack_public_path__ + "img-defaultblankspace.c61787132a6148c4c2ba8663a88154b2.hashedasset.svg";